// src/hooks/useTransactions.js


import { useEffect, useState } from "react";

export const useTransactions = (api, params = {}) => {
  const [transactions, setTransactions] = useState([]);
  const [summary, setSummary] = useState({
    totalCredit: 0,
    totalDebit: 0,
  });
  const [loading, setLoading] = useState(true);

  const fetchTransactions = async () => {
    if (!api) return;

    try {
      setLoading(true);
      const { data } = await api(params);

      if (!data?.success) return;

      let txns = [];

      // ✅ CASE 1: NORMAL APIs (flat)
      if (Array.isArray(data.data) && data.data[0]?.amount) {
        txns = data.data.map((txn) => ({
          id: txn._id, // added this to fix the row issue 
          customer: txn.userId?.name || txn.userName || "N/A",
          phone: txn.userId?.phone || "N/A",
          accountNumber: txn.accountNumber,
          type: txn.type,
          amount: txn.amount,
          balance: txn.newBalance,
          doneBy: txn.performedBy?.id?.name || "Admin",
          date: txn.createdAt,
        }));
      }

      // ✅ CASE 2: STAFF GROUPED API
      else if (Array.isArray(data.data) && data.data[0]?.transactions) {
        txns = data.data.flatMap((staff) =>
        // staff.transactions.map((txn) => ({
          staff.transactions.map((txn, index) => ({
            id: `${staff._id}-${txn.accountNumber}-${txn.createdAt}-${index}`, // added as a fix of row id issue
            customer: txn.userName,
            phone: "N/A",
            accountNumber: txn.accountNumber,
            type: txn.type,
            amount: txn.amount,
            balance: txn.newBalance,
            doneBy: staff.staffName,
            date: txn.createdAt,
          }))
        );
      }

      // ✅ SORT
      txns.sort((a, b) => new Date(b.date) - new Date(a.date));

      setTransactions(txns);

      // ✅ SUMMARY
      const totalCredit = txns
        .filter((t) => t.type === "credit")
        .reduce((sum, t) => sum + t.amount, 0);

      const totalDebit = txns
        .filter((t) => t.type === "debit")
        .reduce((sum, t) => sum + t.amount, 0);

      setSummary({ totalCredit, totalDebit });

    } catch (error) {
      console.error("Transaction fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [api, JSON.stringify(params)]); // ✅ IMPORTANT

  return { transactions, summary, loading };
};
